import React from 'react';

import isEmpty from 'lodash.isempty';

import {FlatButton} from '@pb/kit-component-button';
import {Group} from '@pb/kit-component-group';
import {Icon, Icons, Sizes} from '@pb/kit-component-icon';
import {Scrollable} from '@pb/kit-component-scrollable';
import StripOfPills, {Pill} from '@pb/kit-component-strip-of-pills';

import {clearAllButton, criteriaStrip, criteriaStripScrollable} from './criteria-strip.module.styl';

type Props = {
    data: Array<Stripe>,
    clearAllFilters: () => void,
};

export type Stripe = {
    caption?: string,
    pills: Array<string>,
    onRemove: (name: string) => void,
};

export const CriteriaStrip = ({data, clearAllFilters}: Props) => {
    const isCriteriaEmpty = data.every(group => isEmpty(group.pills));

    return !isCriteriaEmpty ? (
        <Group className={`${criteriaStrip} pt-l`}>
            <Scrollable absolute={true} mix={criteriaStripScrollable}>
                {
                    data.map(stripe => (
                        stripe.pills.length > 0 ? (
                            <StripOfPills
                                key={stripe.caption}
                                label={stripe.caption}>
                                {stripe.pills.map(name => (
                                    <Pill
                                        key={name}
                                        name={name}
                                        removable={true}
                                        onRemove={() => stripe.onRemove(name)}
                                    />
                                ))}
                            </StripOfPills>
                        ) : null
                    ))
                }
                <span className={clearAllButton}>&nbsp;</span>
                <FlatButton
                    startIcon={<Icon type={Icons.TRASH_LIGHT} size={Sizes.Size_16}/>}
                    onClick={clearAllFilters}>
                    Clear all
                </FlatButton>
            </Scrollable>
        </Group>
    ) : null;
};
